import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import {Consts} from "../pages/consts";
import Icd10Tree from "./Icd10Tree";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";

const Disease = ({
                   showDialog,
                   closeDialog,
                   patientDiseases,
                   onSetPatientDiseases,
                   diseasesToShow,
                   setAlreadyAddedError
                 }) => {
  const {t: t} = useTranslation();
  const [icd10Data, setIcd10Data] = useState([]);
  const context = useContext(InitContext);
  const {loading, error, clearError, getDiseasesJson} = useMmcService();

  useEffect(() => {
    if (context?.token && context?.token !== "") {
      clearError();

      getDiseasesJson(context?.token).then((data) => {
        setIcd10Data(data);
      });
    }
  }, []);

  const errorMessage = error && (
    <ErrorMessage message={ t("error_by_retrieving_a_list_of_all_diseases") }/>
  );

  const spinner = loading && <Spinner/>;

  return (
    <div>
      <div className="w3-modal" style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }>
        <div className="w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-wide">
          <header className="w3-container w3-padding-small w3-center">
            <p>{ t("please_select_disease") }</p>
          </header>
          { errorMessage }
          { spinner }
          <div className="w3-container w3-padding-small">
            <div className="w3-row">
              <div className="w3-col diseases-scroll">
                <div className="w3-container w3-padding">
                  <Icd10Tree
                    data={ icd10Data }
                    patientDiseases={ patientDiseases }
                    onSetPatientDiseases={ onSetPatientDiseases }
                    closeDialog={ closeDialog }
                    diseasesToShow={ diseasesToShow }
                    setAlreadyAddedError={ (value) => setAlreadyAddedError(value) }
                  />
                </div>
              </div>
              <div className="w3-right w3-padding-small ">
                <button
                  onClick={ closeDialog }
                  className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
                  type="text"
                >
                  { t("close") }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disease;
